import {Validator} from './Validator';


const validEmail: Validator = (input: string) => {
  return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input)) ? null : 'Invalid email address';
};

export {validEmail};